import { useRef, useState } from 'react';
import { sendMessage } from './use-message';

export const useRemoveMember = (
  url: string,
  data: Record<string, string>,
  messages: {
    failure: string;
    success: string;
  }
) => {
  const abortControllerRef = useRef<AbortController>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [outcome, setOutcome] = useState<'SUCCESS' | 'FAILURE'>();

  const abort = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  const execute = async (onCompletion: () => void) => {
    setIsSubmitting(true);
    setOutcome(undefined);

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const response = await fetch(url, {
        body: new URLSearchParams(data),
        headers: { accept: 'application/json' },
        method: 'delete',
        signal: abortController.signal,
      });

      setOutcome(response.ok ? 'SUCCESS' : 'FAILURE');
      sendMessage(
        response.ok
          ? { text: messages.success, theme: 'success' }
          : { text: messages.failure, theme: 'error' }
      );
    } catch {
      setOutcome(undefined);
    } finally {
      setIsSubmitting(false);
      onCompletion();
    }
  };

  return [execute, abort, isSubmitting, outcome] satisfies [
    typeof execute,
    typeof abort,
    typeof isSubmitting,
    typeof outcome,
  ];
};
